module.exports = __webpack_public_path__ + "static/img/pedals-eq.b9756d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-eq.png
// module id = yJVV
// module chunks = 12